import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CandidateCardModel, CandidateSelectionValue } from './candidate-card.models';

@Component({
  selector: 'app-candidate-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './candidate-card.component.html',
  styleUrls: ['./candidate-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateCardComponent {
  @Input({ required: true }) candidate!: CandidateCardModel;
  @Input() selectionMode = false;
  @Input() selected = false;
  @Input() disabled = false;

  @Output() candidateClick = new EventEmitter<CandidateSelectionValue>();

  get shouldShowSelectionCheck(): boolean {
    return this.selectionMode && this.selected;
  }

  get shouldShowStatusBadge(): boolean {
    if (this.shouldShowSelectionCheck) {
      return false;
    }

    if (!this.candidate.isElectionActive && this.candidate.isElected) {
      return true;
    }

    return this.candidate.votePercentage !== null && this.candidate.votePercentage !== undefined;
  }

  get statusBadgeLabel(): string {
    if (!this.candidate.isElectionActive && this.candidate.isElected) {
      return 'Eleito';
    }

    if (this.candidate.votePercentage === null || this.candidate.votePercentage === undefined) {
      return '';
    }

    return `${this.candidate.votePercentage.toFixed(1).replace('.', ',')}%`;
  }

  get cardEyebrow(): string {
    return this.candidate.isBlankVoteOption
      ? 'Opção de voto em branco'
      : `Candidato ${this.candidate.candidateNumber}`;
  }

  get metaLine(): string {
    if (this.candidate.isBlankVoteOption) {
      return this.selectionMode
        ? 'Nenhum candidato será selecionado.'
        : 'Participações registradas sem indicação de candidato.';
    }

    return this.candidate.department;
  }

  get footerText(): string {
    if (this.candidate.totalVotes !== null && this.candidate.totalVotes !== undefined) {
      return this.candidate.isBlankVoteOption
        ? `${this.candidate.totalVotes} votos em branco computados até o momento`
        : `${this.candidate.totalVotes} votos computados até o momento`;
    }

    if (this.candidate.isBlankVoteOption) {
      return 'Selecione esta opção caso não queira votar em nenhum candidato.';
    }

    if (this.candidate.yearsAtCompany) {
      return `Tempo de empresa: ${this.candidate.yearsAtCompany} anos`;
    }

    return '';
  }

  get shouldShowPosition(): boolean {
    return !!this.candidate.position;
  }

  getCandidateInitials(): string {
    if (this.candidate.isBlankVoteOption) {
      return 'VB';
    }

    return this.candidate.name
      .split(' ')
      .filter((part) => !!part.trim())
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() ?? '')
      .join('');
  }

  handleClick(): void {
    if (!this.selectionMode || this.disabled) {
      return;
    }

    this.candidateClick.emit(this.candidate.selectionValue ?? this.candidate.id);
  }
}
